import { Component, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ProformaRepository } from 'src/app/proforma/domain/proforma.repository';
import { proformaRequest } from 'src/app/proforma/domain/request/proforma_request';
import { ListItem } from 'src/app/proforma/domain/response/proforma_response';
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { DashBoardRepository } from 'src/app/dashboardVentas/domain/dashboard.repository';
// import { ListaejecutivosTeusCerradosRequest } from '../../domain/request/teuscerradosRequest';
import { dropdownItems, UtilService } from 'src/app/services/util.service';
import { requestClientesRecuperados } from 'src/app/dashboardVentas/domain/request/dashboard.request';
import { newmetadate } from 'src/app/shared/components/datatable/domain/datatable-domain';
// import { ReportesRepository } from 'src/app/reporte-ventas/domain/reportes.repository';
// import { FiltrosMultiSelect } from 'src/app/reporte-ventas/domain/request/reporte-ventas-request';
import { ReporteClientesAnioEtaDetalleRequest } from 'src/app/reporte-ciclo-embarque/domain/reporte-ciclo-embarque-request';
import { StorageService } from 'src/app/services/storage.service';
import { TabView } from 'primeng/tabview';
import { ReportesRepository } from 'src/app/repositorio/reportes.repository';
import { FiltrosMultiSelect } from 'src/app/comercial/reportes/reporte-ventas/domain/reporte-ventas.request';
import { ListaejecutivosTeusCerradosRequest } from 'src/app/dashboard-teus-cerrados/domain/request/teuscerradosRequest';

@Component({
    selector: 'app-page-teus-eta-ejecutivo',
    templateUrl: './page-teus-eta-ejecutivo.component.html',
    styleUrls: ['./page-teus-eta-ejecutivo.component.css'],
    standalone: false
})
export class TeusetaejecutivoComponent {
  group: FormGroup
  listReg: ListItem[] = [];

  teuvstargetejecutivo: any = [];
  teuvstargetejecutivo2: any = [];
  teuvstargetejecutivo3: any = [];
  teuvstargetejecutivo4: any = [];
  chartClientesRecuperados: any = [];

  teuvstargetproporcionalemes: any = [];
  teuvstargetemes: any = [];

  constructor(private readonly proformaService: ProformaRepository,
    private readonly ejecutivosService: DashBoardRepository,
    private readonly servicios: UtilService,
    private readonly servReportes: ReportesRepository,
    private readonly util: UtilService,
    private readonly servProforma: ProformaRepository,
    private readonly storage: StorageService

  ) { }
  fechaactual
  fechasuperior
  dato1 = true
  dato2 = true
  parametros: any[] = []

  activeIndex: number = 0
  hasLoaded: boolean[] = Array(11).fill(false);
  onTabChange(event: any) {
    const header = (event.originalEvent.currentTarget.innerText).toString();

    if (!this.hasLoaded[header]) {
      this.hasLoaded[header] = true;
    }

  }


  varactivo: any[] = []; // Asegúrate de inicializar varactivo como un array o lo que necesites.

  // Lista de códigos que quieres verificar
  codigosPermitidos: string[] = [] //['108', '109'];

  // Función que valida si varactivo contiene los códigos necesarios
  tieneCodigosValidos(codigomenu): boolean {

    return this.codigosPermitidos.some(codigo => codigo == codigomenu);

  }

  @ViewChild('TabComercial') tabView: TabView;

  ANIOS: dropdownItems[] = this.util.getAnios()
    MESES: dropdownItems[] = this.util.getMeses().filter(x => x.value !== 'TODOS');
    


  async ngOnInit(): Promise<void> {


    if (this.storage.get('rol') === '17') {

      this.codigosPermitidos.push('108')

    } else if (this.storage.get('rol') === '1026') {

      this.codigosPermitidos.push('109')

    } else {
      this.codigosPermitidos.push('1')
      this.codigosPermitidos.push('2')
      this.codigosPermitidos.push('3')
      this.codigosPermitidos.push('4')
      this.codigosPermitidos.push('5')
      this.codigosPermitidos.push('6')
      this.codigosPermitidos.push('7')
      this.codigosPermitidos.push('8')
      this.codigosPermitidos.push('108')
      this.codigosPermitidos.push('109')
    }

    const fechas = new Date();
    this.fechaactual = this.servicios.formatearfecha(fechas, 'dd/mm/yyyy')
    this.fechasuperior = this.servicios.formatearfecha(fechas, 'mm/yyyy')
    this.listarAnios()
    this.iniciarFormulario();
    this.cargaLista("RGM");
    this.radioaccion1();
    this.parametros = await this.util.getParametros()
    this.cargarinformacion()

     const month = (new Date()).getMonth() + 1
    const formattedMonth = month < 10 ? '0' + month : month.toString()

    this.group.get('anio').setValue((new Date()).getFullYear())
    this.group.get('mes').setValue(formattedMonth)
this.group.get('lineanegocio').setValue('MANDATO')
this.group.get('regimen').setValue('IMPORTACIONES')


    
    

  }

  ngAfterViewInit() {
    const header = (this.tabView.tabs[0].header).toString();

    if (!this.hasLoaded[header]) {
      this.hasLoaded[header] = true;
    }
  }

  listaAnios: any[] = []
  listarAnios() {
    this.servProforma.ListarAnio('').subscribe(response => {
      // Extrae los años del response
      const anios = response.datos.result.map(item => item.anio);

      // Ordena los años de mayor a menor
      anios.sort((a, b) => b - a);

      // Construye la lista de años con el formato adecuado
      this.listaAnios = anios.map(anio => ({
        label: anio.toString(),
        value: anio.toString()
      }));
    });
  }
  iniciarFormulario() {
    this.group = new FormGroup({
      fechas: new FormControl('a', null),
      fechainicio: new FormControl(null, Validators.required),
      fechafin: new FormControl(null, Validators.required),
      regimen: new FormControl('TODOS', null),
      lineanegocio: new FormControl('TODOS', null),
      anio: new FormControl(null, null),
      mes: new FormControl(null, null)
    });
    this.groupPareto = new FormGroup({
      anio: new FormControl(null, null),
      regimen: new FormControl(null, null),
      lineanegocio: new FormControl(null, null)
    })
    this.groupBudget = new FormGroup({
      anio: new FormControl(null, null),
      regimen: new FormControl(null, null),
      lineanegocio: new FormControl(null, null)
    })
  }
  parameters(type: string): any[] {
    let value: any[] = []
    // const parametros = this.util.getParametros()

    // parametros['__zone_symbol__value']
    const item = {

    }
    let i = 0
    this.parametros.forEach(r => {

      if (r.tipo === type) {
        if (r.nombre !== 'SERVICIO INTEGRADO LOCAL' && r.nombre !== 'SEGUROS' && r.nombre !== 'SERVICIO LOGISTICO INTEGRAL') {
          value.push(r)
        }

      }
    });

    return value
  }
  radioaccion1() {

    const fechaActual = new Date();

    const primerDiaMes = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 1);

    this.group.controls['fechainicio'].disable();
    this.group.controls['fechafin'].disable();
    this.group.controls['fechainicio'].setValue(primerDiaMes);
    this.group.controls['fechafin'].setValue(fechaActual);

  }

  radioaccion2() {
    this.group.controls['fechainicio'].enable();
    this.group.controls['fechafin'].enable();
    this.group.controls['fechainicio'].setValue('');
    this.group.controls['fechafin'].setValue('');
  }

  cargaLista(value: string) {
    const requestProforma: proformaRequest = <proformaRequest>{};
    requestProforma.pchrCONS_CodTabla = value;
    this.proformaService.listar(requestProforma).subscribe(response => {
      if (value == "RGM") {
        this.listReg.splice(0, this.listReg.length);
        for (let i = 0; i < response.datos.result.length; i++) {
          const item: ListItem = {
            nombre: response.datos.result[i].conS_Desc_SPA,
            codigo: response.datos.result[i].conS_CodTipo
          };
          this.listReg.push(item);
        }
      }
    }
    );
  }

  teusOtrosEjecutivos: any
  pc: boolean
  graficoteustargetejecutivo() {
    let pc = false
    const screenWidth = window.innerWidth;
    if (screenWidth <= 768) {
      pc = false;
    } else {
      pc = true;
    }
    this.teuvstargetejecutivo = new Chart('canvas1', {
      type: 'bar',
      data: {
        labels: this.listaejecutivos,
        xLabels: this.listaejecutivos,

        datasets: [
          {
            label: 'TEU',
            data: this.teus,
            borderWidth: 1,
            barPercentage: 0.9,
            borderRadius: 0,

            //  barThickness: 4,

            backgroundColor: 'rgba(47, 246, 110, 0.5)',
            borderColor: 'rgb(47, 246, 110)',
            datalabels: {
              color: 'black',
              display: function (context) {
                return context.dataset.data[context.dataIndex] !== 0;
              },
              font: {
                weight: 'normal',
                size: pc == true ? 10 : 6,
              },



            }
          },
          {
            label: '*BudM',
            data: this.budm,
            barPercentage: 0.9,
            borderRadius: 0,
            borderWidth: 1,
            backgroundColor: 'rgba(66, 152, 232, 0.5)',
            borderColor: 'rgb(66, 152, 232)',
            datalabels: {
              color: 'black',
              display: function (context) {
                return context.dataset.data[context.dataIndex] !== 0;
              },
              font: {
                weight: 'normal',
                size: pc == true ? 10 : 6,
              },
            }
          }
        ],
      },
      plugins: [ChartDataLabels],
      options: {
        indexAxis: 'y',
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              font: {
                size: pc == true ? 10 : 6,
                weight: '600'
              }
            },
            grid: { display: false }
          },
          x: {

            ticks: {
              font: {
                size: pc == true ? 9 : 6,
                weight: '600'
              }
            },
            grid: { display: false }

          }
        },
        plugins: {
          legend: {
            position: 'top',
            labels: {
              font: {
                size: pc == true ? 9 : 6, // Tamaño de fuente de la leyenda
              },
            },
          },
          datalabels: {
            display: true, // Mostrar las etiquetas
            anchor: 'end', // Alinear las etiquetas al final de la barra
            align: 'end',  // Alinear las etiquetas al final de la barra
            formatter: function (value, context) {
              return Math.round(value); // Redondear el valor y mostrarlo en la etiqueta
            },
          },
          tooltip: {
            enabled: true,
            titleFont: { size: 9 },
            bodyFont: { size: 9 },
          }
        },
        // Core options
        aspectRatio: 4.1 / 2.2,
        layout: {
          padding: {
            top: 15,
            right: 30,
            bottom: 16,
            left: 30
          }
        },
        elements: {
          line: {
            fill: false,
            tension: 0.4
          }
        },
        // scales: {
        //   y: {
        //     stacked: true
        //   }
        //},
      },
    });

    this.teusOtrosEjecutivos = new Chart('canvas_otros_ejecutivos', {
      type: 'bar',
      data: {
        labels: this.ejecutivos,
        xLabels: this.ejecutivos,

        datasets: [
          {
            label: 'TEU',
            data: this.teus_otros,
            borderWidth: 1,
            barPercentage: 0.9,
            borderRadius: 0,

            //  barThickness: 4,

            backgroundColor: 'rgba(47, 246, 110, 0.5)',
            borderColor: 'rgb(47, 246, 110)',
            datalabels: {
              color: 'black',
              display: function (context) {
                return context.dataset.data[context.dataIndex] !== 0;
              },
              font: {
                weight: 'normal',
                size: pc == true ? 10 : 6,
              },
            }
          },
          {
            label: '*BudM',
            data: this.budm_otros,
            barPercentage: 0.9,
            borderRadius: 0,
            borderWidth: 1,
            //barThickness: 4,
            backgroundColor: 'rgba(66, 152, 232, 0.5)',
            borderColor: 'rgb(66, 152, 232)',
            datalabels: {
              color: 'normal',
              display: function (context) {
                return context.dataset.data[context.dataIndex] !== 0;
              },
              font: {
                weight: 'bold',
                size: pc == true ? 10 : 6,
              },
            }
          }
        ],
      },
      plugins: [ChartDataLabels],
      options: {
        indexAxis: 'y',
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              font: {
                size: pc == true ? 10 : 6,
              }
            },
            grid: { display: false }
          },
          x: {

            ticks: {
              font: {
                size: pc == true ? 10 : 6,
              }
            },
            grid: { display: false }

          }
        },
        plugins: {
          legend: {
            position: 'top',
            labels: {
              font: {
                size: pc == true ? 9 : 6, // Tamaño de fuente de la leyenda
              },
            },
          },
          datalabels: {
            display: true, // Mostrar las etiquetas
            anchor: 'end', // Alinear las etiquetas al final de la barra
            align: 'end',  // Alinear las etiquetas al final de la barra
            formatter: function (value, context) {
              return Math.round(value); // Redondear el valor y mostrarlo en la etiqueta
            },
          },
          tooltip: {
            enabled: true,
            titleFont: { size: 9 },
            bodyFont: { size: 9 },
          }
        },
        // Core options
        aspectRatio: 4.1 / 2.2,
        layout: {
          padding: {
            top: 20,
            right: 16,
            bottom: 16,
            left: 16
          }
        },
        elements: {
          line: {
            fill: false,
            tension: 0.4
          }
        },

        // scales: {
        //   y: {
        //     stacked: true
        //   }
        //},
      },
    });
  }

  graficoteuslinea() {
    const colores: string[] = [
      '#82CB45', '#1967B6', '#FF5733', '#F5F33C', 'lightgreen'
    ];
    const provicional: string[] = [
      'white', 'white', 'white', 'black', 'white'
    ];
    const screenWidth = window.innerWidth;
    if (screenWidth <= 768) {
      this.pc = false;
    } else {
      this.pc = true;
    }
    this.teuvstargetejecutivo2 = new Chart('canvas2', {
      type: 'bar',
      data: {
        labels: this.linea,
        xLabels: this.linea,

        datasets: [
          {
            label: 'TEU',
            data: this.lineateu,
            borderWidth: 1,
            barPercentage: 1,
            borderRadius: 5,

            //  barThickness: 4,

            backgroundColor: colores,
            datalabels: {
              color: provicional,
              display: true,
              font: {
                weight: 'bold',
                size: this.pc == true ? 13 : 8,
              },
            }
          }
        ],
      },
      plugins: [ChartDataLabels],
      options: {
        indexAxis: 'y',
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              font: {
                size: this.pc == true ? 12 : 6,
              }
            },
            grid: { display: false }
          },
          x: {

            ticks: {
              font: {
                size: this.pc == true ? 12 : 6,
              }
              , stepSize: 100,
            },
            grid: { display: false }

          }
        },
        plugins: {
          legend: {
            display: false,
            position: 'top',
            labels: {
              font: {
                size: this.pc == true ? 12 : 6, // Tamaño de fuente de la leyenda
              },
            },
          },
          datalabels: {
            display: true, // Mostrar las etiquetas
            formatter: function (value, context) {
              return Math.round(value); // Redondear el valor y mostrarlo en la etiqueta
            },
          },
        },
        // Core options
        aspectRatio: 5 / 3,
        layout: {
          padding: {
            top: 32,
            right: 16,
            bottom: 16,
            left: 8
          }
        },
        elements: {
          line: {
            fill: false,
            tension: 0.4
          }
        },
        // scales: {
        //   y: {
        //     stacked: true
        //   }
        //},
      },
    });
  }

  cabecera = ['Total']
  graficoteustargetproporcionalmes() {
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
    if (screenWidth <= 768) {
      this.pc = false;
    } else {
      this.pc = true;
    }

    this.teuvstargetejecutivo3 = new Chart('canvas3', {
      type: 'bar',
      data: {
        labels: this.cabecera,
        xLabels: this.cabecera,

        datasets: [
          {
            label: 'TEU',
            data: this.totalteus,
            borderWidth: 1,
            barPercentage: 1,
            borderRadius: 5,

            //  barThickness: 4,

            backgroundColor: 'lightgreen',
            datalabels: {
              color: 'black',
              display: true,
              font: {
                weight: 'bold',
                size: this.pc == true ? 13 : 8,
              },
            }
          },
          {
            label: '*BudMTD',
            data: this.totalbudmtd,
            barPercentage: 1,
            borderRadius: 5,
            borderWidth: 1,
            //barThickness: 4,
            backgroundColor: 'rgba(0, 0, 255, 0.5)',
            datalabels: {
              color: 'black',
              display: true,
              font: {
                weight: 'bold',
                size: this.pc == true ? 13 : 8,
              },
            }
          }
        ],
      },
      plugins: [ChartDataLabels],
      options: {
        indexAxis: 'x',
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              font: {
                size: this.pc == true ? 12 : 6,
              }
            },
            grid: { display: false }
          },
          x: {

            ticks: {
              font: {
                size: this.pc == true ? 12 : 6,
              }
            },
            grid: { display: false }

          }
        },
        plugins: {
          legend: {
            position: 'top',
            labels: {
              font: {
                size: this.pc == true ? 12 : 6, // Tamaño de fuente de la leyenda
              },
            },
          },
          datalabels: {
            display: true, // Mostrar las etiquetas
            anchor: 'end', // Alinear las etiquetas al final de la barra
            align: 'end',  // Alinear las etiquetas al final de la barra
            formatter: function (value, context) {
              return Math.round(value); // Redondear el valor y mostrarlo en la etiqueta
            },
          },
        },
        // Core options
        aspectRatio: 5 / 3,
        layout: {
          padding: {
            top: 32,
            right: 16,
            bottom: 16,
            left: 8
          }
        },
        elements: {
          line: {
            fill: false,
            tension: 0.4
          }
        },
        // scales: {
        //   y: {
        //     stacked: true
        //   }
        //},
      },
    });
  }

  graficoteustargetmes() {
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
    if (screenWidth <= 768) {
      this.pc = false;
    } else {
      this.pc = true;
    }
    this.teuvstargetejecutivo4 = new Chart('canvas4', {
      type: 'bar',
      data: {
        labels: this.cabecera,
        xLabels: this.cabecera,

        datasets: [
          {
            label: 'TEU',
            data: this.totalteus,
            borderWidth: 1,
            barPercentage: 1,
            borderRadius: 5,

            //  barThickness: 4,

            backgroundColor: 'lightgreen',
            datalabels: {
              color: 'black',
              display: true,
              font: {
                weight: 'bold',
                size: this.pc == true ? 13 : 8,
              },
            }
          },
          {
            label: '*BudM',
            data: this.totalbudm,
            barPercentage: 1,
            borderRadius: 5,
            borderWidth: 1,
            //barThickness: 4,
            backgroundColor: 'rgba(0, 0, 255, 0.5)',
            datalabels: {
              color: 'black',
              display: true,
              font: {
                weight: 'bold',
                size: this.pc == true ? 13 : 8,
              },
            }
          }
        ],
      },
      plugins: [ChartDataLabels],
      options: {
        indexAxis: 'x',
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              font: {
                size: this.pc == true ? 12 : 6,
              }
            },
            grid: { display: false }
          },
          x: {

            ticks: {
              font: {
                size: this.pc == true ? 12 : 6,
              }
            },
            grid: { display: false }

          }
        },
        plugins: {
          legend: {
            position: 'top',
            labels: {
              font: {
                size: this.pc == true ? 12 : 6, // Tamaño de fuente de la leyenda
              },
            },
          },
          datalabels: {
            display: true, // Mostrar las etiquetas
            anchor: 'end', // Alinear las etiquetas al final de la barra
            align: 'end',  // Alinear las etiquetas al final de la barra
            formatter: function (value, context) {
              return Math.round(value); // Redondear el valor y mostrarlo en la etiqueta
            },
          },
        },
        // Core options
        aspectRatio: 5 / 3,
        layout: {
          padding: {
            top: 32,
            right: 16,
            bottom: 16,
            left: 8
          }
        },
        elements: {
          line: {
            fill: false,
            tension: 0.4
          }
        },
        // scales: {
        //   y: {
        //     stacked: true
        //   }
        //},
      },
    });
  }

  cantidadClientesRecuperados: number[] = [];
  cantidadClientesOtros: number[] = [];
  mesesClientesRecuperados: string[] = [];
  graficoBarrasClientesRecuperados() {
    const screenWidth = window.innerWidth;
    if (screenWidth <= 768) {
      this.pc = false;
    } else {
      this.pc = true;
    }

    this.chartClientesRecuperados = new Chart('canvasClientesRecuperados', {
      type: 'bar',
      data: {
        labels: this.mesesClientesRecuperados,
        xLabels: this.mesesClientesRecuperados,

        datasets: [
          {
            label: 'EJECUTIVOS',
            data: this.cantidadClientesRecuperados,
            borderWidth: 1,
            barPercentage: 1,
            borderRadius: 5,

            //  barThickness: 4,
            backgroundColor: 'rgba(0, 0, 255, 0.5)',
            datalabels: {
              color: 'black',
              display: true,
              font: {
                weight: 'bold',
                size: this.pc == true ? 13 : 8,
              },
            }
          },
          {
            label: 'OTROS EJECUTIVOS',
            data: this.cantidadClientesOtros,

            borderWidth: 1,
            barPercentage: 1,
            borderRadius: 5,

            //  barThickness: 4,
            backgroundColor: 'lightgreen',
            datalabels: {
              color: 'black',
              display: true,
              font: {
                weight: 'bold',
                size: this.pc == true ? 13 : 8,
              },
            }
          },
        ],
      },
      plugins: [ChartDataLabels],
      options: {
        indexAxis: 'x',
        plugins: {
          legend: {
            display: true,
            position: 'top',
            labels: {
              font: {
                size: this.pc == true ? 12 : 6, // Tamaño de fuente de la leyenda
              },
            },
          },
          datalabels: {
            display: true,
            anchor: 'center',
            formatter: function (value, context) {
              return Math.round(value);
            },
          },
        },
        // Core options
        aspectRatio: 5 / 3,
        layout: {
          padding: {
            top: 32,
            right: 16,
            bottom: 16,
            left: 8
          }
        },
        elements: {
          line: {
            fill: false,
            tension: 0.4
          }
        },
        scales: {

          x: {
            stacked: true,
            ticks: {
              maxRotation: 90,
              minRotation: 90
            },
            grid: { display: false }
          },
          y: {
            stacked: true,
            grid: { display: false }
          }
        }
      },
    });
  }


  linea: any
  lineateu: any
  totalteus: any
  totalbudmtd: any
  totalbudm: any
  datatlable: any
  listaejecutivos: any
  teus: any
  budm: any
  listaDeMeses = ['ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO', 'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE'];
  listaDeMesesClientesRecuperados = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'];
  mes: string = '';

  ejecutivos: any[] = []
  teus_otros: any[] = []
  budm_otros: any[] = []
  cargarinformacion() {

    if (this.teuvstargetejecutivo instanceof Chart) {
      this.teuvstargetejecutivo.destroy()
    }
    if (this.teuvstargetejecutivo3 instanceof Chart) {
      this.teuvstargetejecutivo3.destroy()
    }
    if (this.teuvstargetejecutivo4 instanceof Chart) {
      this.teuvstargetejecutivo4.destroy()
    }
    if (this.teuvstargetejecutivo2 instanceof Chart) {
      this.teuvstargetejecutivo2.destroy()
    }
    if (this.chartClientesRecuperados instanceof Chart) {
      this.chartClientesRecuperados.destroy();
    }
    if (this.teusOtrosEjecutivos instanceof Chart) {
      this.teusOtrosEjecutivos.destroy();
    }

    this.dato1 = false
    this.dato2 = false

    this.datatlable = []
    this.listaejecutivos = []
    this.teus = []
    this.budm = []
    this.totalbudm = []
    this.totalbudmtd = []
    this.totalteus = []
    this.linea = []
    this.lineateu = []
    this.ejecutivos = []
    this.teus_otros = []
    this.budm_otros = []


    const value = this.group.getRawValue()
    let inicio = value.fechainicio
    let final = value.fechafin
    let regimen = value.regimen
    let linea = value.lineanegocio

    var inicio2 = inicio.toISOString().slice(0, 10) + ' 00:00:00';
    var final2 = final.toISOString().slice(0, 10) + ' 00:00:00';


    const request: ListaejecutivosTeusCerradosRequest = <ListaejecutivosTeusCerradosRequest>{}

    request.fechaInicio = inicio2
    request.fechaFin = final2
    request.tipo = 1
    request.regimen = regimen
    request.lineanegocio = linea
    
    let periodo = value.anio + '' + value.mes
    request.periodo = Number(periodo)

    this.ejecutivosService.ListaejecutivosTeusCerradosETA(request).subscribe(response => {
      if (response.datos.status === 200) {
        const datos = response.datos.result;
        datos.forEach(dato => {
          if (dato.entc_codejecutivo != 16642 && dato.entc_codejecutivo != 16643 && dato.entc_codejecutivo != 16712) {
            this.listaejecutivos.push(dato.entc_nomcompleto.toUpperCase());
            this.teus.push(dato.cantidad)
            this.budm.push(dato.monto)
          } else {
            this.ejecutivos.push(dato.entc_nomcompleto.toUpperCase());
            this.teus_otros.push(dato.cantidad)
            this.budm_otros.push(dato.monto)
          }

        });
        this.datatlable = datos

        console.log("datatlable", this.datatlable)

        this.totalteus.push(this.parseNumber(this.getTotalCost('cantidad', this.datatlable)))
        this.totalbudmtd.push(this.parseNumber(this.getTotalCost('budmtd', this.datatlable)))

        this.totalbudm.push(this.parseNumber(this.getTotalCost('monto', this.datatlable)))

        this.graficoteustargetejecutivo();
        this.graficoteustargetproporcionalmes();
        this.graficoteustargetmes();
      }
    });

    request.tipo = 2

    this.ejecutivosService.ListateusLinea(request).subscribe(response => {
      if (response.datos.status === 200) {
        const datos = response.datos.result;
        datos.forEach(dato => {
          this.lineateu.push(dato.cantidad)
          this.linea.push(dato.linea)
        });

        // this.teuvstargetejecutivo2.destroy()
        this.graficoteuslinea()
      }
    });

    const values = this.group.value;
    const clientesRecuperadosRequest: requestClientesRecuperados = <requestClientesRecuperados>{};

    if (values.anio != null && values.anio != undefined && values.anio != '' &&
      values.mes != null && values.mes != undefined && values.mes != '') {
      clientesRecuperadosRequest.periodo = values['anio'] + values['mes'];
      this.mes = this.listaDeMeses[parseInt(values['mes']) - 1];
    } else {
      let date = new Date();
      this.mes = this.listaDeMeses[date.getMonth()];
      let year = date.getFullYear().toString();
      let month = (date.getMonth() + 1).toString().padStart(2, '0'); // Agrega ceros a la izquierda si es necesario
      clientesRecuperadosRequest.periodo = year + month;
    }

    //requestTransportista.tipo = 'P';
    clientesRecuperadosRequest.fechaInicio = null;
    clientesRecuperadosRequest.fechaFin = null;

    this.ejecutivosService.listaClientesRecuperados(clientesRecuperadosRequest).subscribe(response => {
      if (response.datos.status === 200) {
        this.mesesClientesRecuperados.splice(0, this.mesesClientesRecuperados.length);
        this.cantidadClientesRecuperados.splice(0, this.cantidadClientesRecuperados.length);
        this.cantidadClientesOtros.splice(0, this.cantidadClientesOtros.length);
        for (let i = 0; i < response.datos.result.length; i++) {
          this.mesesClientesRecuperados.push(this.listaDeMesesClientesRecuperados[response.datos.result[i].mes - 1])
          this.cantidadClientesRecuperados.push(response.datos.result[i].cantidad)
          this.cantidadClientesOtros.push(response.datos.result[i].cantidadotros)
        }


        this.graficoBarrasClientesRecuperados()
        this.chartClientesRecuperados.update()
        this.dato2 = true
      }
    });


  }


  getTotalCost(columnName: string, arr: any): string {
    let total = 0
    if (arr != undefined) {
      const columnData = (arr.map(row => this.parseNumber(row[columnName] == null ? row[columnName] : row[columnName].toString())));
      total = columnData.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    }
    return total.toLocaleString('es-PE');
  }

  parseNumber(numberString: string): number {
    let sanitizedString
    if (numberString != null) {
      const formattedString = numberString.replace(',', '&');
      sanitizedString = formattedString.replace('&', '');
    }
    return parseFloat(sanitizedString);
  }

  formatear2decimales(value: number) {
    return value.toFixed(2)
  }

  // Pareto
  paretoVendedorDetalle: any[] = []
  groupPareto: FormGroup
  metadatatable4: newmetadate[] = [
    { field: 'vendedor', title: 'Vendedor', inputType: 'text', style: { align: 'left', justify: 'left' } },
    { field: 'cliente', title: 'cliente efectivo', inputType: 'text', style: { align: 'left', justify: 'left' } },
    { field: 'teus', title: 'teus', inputType: 'int', rowFooter: 'sum' },
    { field: 'ochenta', title: '80%', inputType: 'text', style: { align: 'left', justify: 'left' } },
    { field: 'veinte', title: '20%', inputType: 'text', style: { align: 'left', justify: 'left' } }

  ]
  searchPareto() {
    this.paretoVendedorDetalle = []
    const request = <ReporteClientesAnioEtaDetalleRequest>{}
    const anios: FiltrosMultiSelect[] = []
    const values = this.groupPareto.value

    if (values.anio) {
      values.anio.forEach(r => {
        const item: FiltrosMultiSelect = {
          filt_codigoint: parseInt(r),
          filt_codigovar: '',
          filt_nombre: ''
        }
        anios.push(item)
      });
    }

    request.anio = anios
    request.regimen = values.regimen ? values.regimen.nombre : ''
    request.lineanegocio = values.lineanegocio ? values.lineanegocio.nombre : ''
    request.tiporeporte = 5

    this.servReportes.ReporteParetodeCarteraDetalle(request).subscribe(response => {
      this.paretoVendedorDetalle = response.datos.result
    })
  }

  groupBudget: FormGroup
  dataReporteFlujoProyectado07: any[] = []
  dataReporteFlujoProyectado08: any[] = []
  dataReporteFlujoProyectado09: any[] = []
  dataReporteFlujoProyectado10: any[] = []
  metadataReporteFlujoProyectado: newmetadate[] = [
    { field: 'motivo', title: 'Motivo', inputType: 'text', style: { align: 'left', justify: 'left' } },
    { field: 'enero', title: 'ene', inputType: 'decimal' },
    { field: 'febrero', title: 'feb', inputType: 'decimal' },
    { field: 'marzo', title: 'mar', inputType: 'decimal' },
    { field: 'abril', title: 'abr', inputType: 'decimal' },
    { field: 'mayo', title: 'may', inputType: 'decimal' },
    { field: 'junio', title: 'jun', inputType: 'decimal' },
    { field: 'julio', title: 'jul', inputType: 'decimal' },
    { field: 'agosto', title: 'ago', inputType: 'decimal' },
    { field: 'septiembre', title: 'sep', inputType: 'decimal' },
    { field: 'octubre', title: 'oct', inputType: 'decimal' },
    { field: 'noviembre', title: 'nov', inputType: 'decimal' },
    { field: 'diciembre', title: 'dic', inputType: 'decimal' },
    { field: 'total', title: 'total', inputType: 'decimal' }
  ]
  searchBudget() {
    this.dataReporteFlujoProyectado07 = []
    this.dataReporteFlujoProyectado08 = []
    this.dataReporteFlujoProyectado09 = []
    this.dataReporteFlujoProyectado10 = []
    const request = <ReporteClientesAnioEtaDetalleRequest>{}
    const anios: FiltrosMultiSelect[] = []
    const values = this.groupBudget.value

    if (values.anio) {
      values.anio.forEach(r => {
        const item: FiltrosMultiSelect = {
          filt_codigoint: parseInt(r),
          filt_codigovar: '',
          filt_nombre: ''
        }
        anios.push(item)
      });
    }

    request.anio = anios
    request.regimen = values.regimen ? values.regimen.nombre : ''
    request.lineanegocio = values.lineanegocio ? values.lineanegocio.nombre : ''
    request.tiporeporte = 7
    this.servReportes.ReporteFlujoProyectado07(request).subscribe(response => {
      this.dataReporteFlujoProyectado07 = response.datos.result
    })

    request.tiporeporte = 8
    this.servReportes.ReporteFlujoProyectado07(request).subscribe(response => {
      this.dataReporteFlujoProyectado08 = response.datos.result
    })

    request.tiporeporte = 9
    this.servReportes.ReporteFlujoProyectado07(request).subscribe(response => {
      this.dataReporteFlujoProyectado09 = response.datos.result
    })

    request.tiporeporte = 10
    this.servReportes.ReporteFlujoProyectado07(request).subscribe(response => {
      this.dataReporteFlujoProyectado10 = response.datos.result
      this.dataReporteFlujoProyectado10.forEach(r => {
        // const item = [r.enero, r.febrero, r.marzo, r.abril, r.mayo, r.junio, r.julio, r.agosto, r.septiembre, r.octubre, r.noviembre, r.diciembre]
        // if (r.motivo == 'Budget') { this.listaBudget = item }
        // if (r.motivo == 'Proyeccion Profit Total $') { this.listaTotalProfit = item }
        // if (r.motivo == 'Real') { this.listaReal = item }
        // if (r.motivo == 'Profit Total Final $') { this.listaProfitBudget = item }
      })

    })
  }
}
